import React, { useContext, useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import Message from './Message';
import SimpleBarReact from 'simplebar-react';
import { ChatContext } from 'context/Context';

const ChatContentBody = ({ thread }) => {
  const messagesEndRef = useRef();
  const { scrollToBottom, setScrollToBottom } = useContext(ChatContext);
  const content = thread?.messages;

  useEffect(() => {
    if (scrollToBottom) {
      setTimeout(() => {
        messagesEndRef?.current.scrollIntoView({ behavior: 'auto', block: 'end' });
      }, 500);
      setScrollToBottom(false);
    }
  }, [scrollToBottom]);

  return (
    <div className="chat-content-body" style={{ display: 'inherit' }}>
      <SimpleBarReact style={{ height: '100%' }}>
        <div className="chat-content-scroll-area">
          {content?.map(({ answer, question, id, isPositive }) => (
            <div key={id}>
              {question && <Message message={question} type='q' />}
              {answer && <Message message={answer} type='a' id={id} rating={isPositive} />}
            </div>
          ))}
        </div>
        <div ref={messagesEndRef} style={{ float: "left", clear: "both" }} />
      </SimpleBarReact>
    </div>
  );
};

ChatContentBody.propTypes = {
  thread: PropTypes.object.isRequired
};

export default memo(ChatContentBody);
